import { Check, Minus } from 'lucide-react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

import { cn } from './cn';

export type CheckboxProps = ComponentProps<typeof CheckboxPrimitive.Root> & { readonly readOnly?: boolean };

/** Caixa de seleção (Radix). `checked="indeterminate"` desenha o traço. Alvo de toque de 48px no celular. */
export function Checkbox({ className, readOnly, disabled, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      disabled={disabled === true || readOnly === true}
      className={cn(
        'peer relative inline-flex size-4 shrink-0 items-center justify-center rounded-sm border border-input bg-card text-primary-foreground',
        'transition-colors duration-(--lume-dur-fast) ease-out',
        'data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary',
        'aria-invalid:border-error disabled:cursor-not-allowed disabled:opacity-45',
        'after:absolute after:-inset-4 md:after:-inset-2',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center">
        {props.checked === 'indeterminate' ? (
          <Minus aria-hidden className="size-3.5" strokeWidth={3} />
        ) : (
          <Check aria-hidden className="size-3.5" strokeWidth={3} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
